import { render, staticRenderFns } from "./marshal.vue?vue&type=template&id=45ce2206&scoped=true&"
import script from "./marshal.vue?vue&type=script&lang=js&"
export * from "./marshal.vue?vue&type=script&lang=js&"
import style0 from "./marshal.vue?vue&type=style&index=0&id=45ce2206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce2206",
  null
  
)

component.options.__file = "marshal.vue"
export default component.exports